/**
 * Created by andrey on 10.02.2021.
 */

const Quest = function (data, isNew) {
    cleverapps.EventEmitter.call(this);

    const pageId = cleverapps.meta.selectedLocationId();
    this.config = QuestsConfig[pageId][data.id].quest;
    this.rewards = new RewardsList(this.config.prize || {}, {
        toMainWorld: this.config.toMainWorld,
        event: cleverapps.EVENTS.EARN.QUEST
    });

    this.triggerUnit = QuestsConfig[pageId][data.id].trigger && QuestsConfig[pageId][data.id].trigger.unit;
    this.highlightTargets = QuestsConfig[pageId][data.id].highlightTargets;
    this.findOnStart = QuestsConfig[pageId][data.id].findOnStart;
    this.silentFind = QuestsConfig[pageId][data.id].silentFind;
    this.lockMapDuringStartQuest = QuestsConfig[pageId][data.id].lockMapDuringStartQuest;
    this.campaign = QuestsConfig[pageId][data.id].campaign;
    this.priority = QuestsConfig[pageId][data.id].priority || 0;

    this.id = data.id;
    this.type = this.config.type;
    this.progress = this.lastShownProgress = data.progress || 0;
    this.fresh = data.fresh;
    this.cancelZoomOut = QuestsConfig[pageId][data.id].cancelZoomOut;

    this.recipeCode = data.recipe || data.recipeCode;

    this.dynamic = QuestsConfig[pageId][data.id].dynamic || {};

    if (!data.unit && this.dynamic.getUnit && this.dynamic.getUnit()) {
        this.unit = this.dynamic.getUnit();
    } else {
        this.unit = data.unit || this.config.unit;
    }

    if (isNew && this.dynamic.getGoal) {
        this.goal = this.dynamic.getGoal(this.config);
    } else if (Array.isArray(data.goal)) {
        this.goal = PseudoRandom.GET().random(data.goal[0], data.goal[1]);
    } else {
        this.goal = data.goal || data.amount || 1;
    }
};

Quest.prototype = Object.create(cleverapps.EventEmitter.prototype);
Quest.prototype.constructor = Quest;

Quest.prototype.addProgress = function (amount, options) {
    const wasFinished = this.isFinished();

    if (this.dynamic.addProgress) {
        this.dynamic.addProgress(this, options);
    } else {
        this.progress += (amount || 1);

        if (this.progress > this.goal) {
            this.progress = this.goal;
        }
    }

    if (this.isFinished()) {
        Map2dLocation.currentLocation.counter.setTimeout(() => {
        }, 1000);

        if (!wasFinished) {
            Map2dLocation.currentLocation.quests.trigger("questProgressUpdated");
        }
    }

    Map2dLocation.currentLocation.quests.save();
};

Quest.prototype.wantsToShowProgress = function () {
    return this.progress > this.lastShownProgress;
};

Quest.prototype.setProgressShown = function () {
    this.lastShownProgress = this.progress;
};

Quest.prototype.setFresh = function (fresh) {
    this.fresh = fresh;
};

Quest.prototype.isFresh = function () {
    return this.fresh;
};

Quest.prototype.find = function (silent) {
    if (this.campaign) {
        return UnitLocator.find(this.type, {
            code: this.unit.code,
            stage: this.unit.stage - 1
        }, {
            useStageForCustomerSearch: true,
            allowScrollWithFocus: true
        });
    }

    const findOptions = { ...this.config, allowScrollWithFocus: true, silent };

    if (this.unit && this.unit.code && Families[this.unit.code].locators) {
        findOptions.getFindTargets = function () {
            return Families[this.unit.code].locators;
        }.bind(this);
    }

    return UnitLocator.find(this.type, this.unit, findOptions);
};

Quest.prototype.dynamicFinished = function () {
    if (this.isFresh()) {
        return false;
    }

    if (this.dynamic.finished && this.dynamic.finished()) {
        return true;
    }

    switch (this.type) {
        case Map2d.OPEN_UNIT:
            return cleverapps.unitsLibrary.isOpened(this.unit);
        default:
            return false;
    }
};

Quest.prototype.isFinished = function () {
    return this.progress >= this.goal;
};

Quest.prototype.getTitle = function () {
    if (this.dynamic.getTitle) {
        return this.dynamic.getTitle(this.unit);
    }

    const toReplace = {};

    if (this.unit) {
        toReplace.name = cleverapps.unitsLibrary.getUnitName(this.unit);

        if (this.unit.code === "wands") {
            return Messages.get("Quest.wands.title");
        }

        const family = Families[this.unit.code];
        if (family && ["hero", "rphero"].includes(family.type) && this.unit.stage === family.units.length - 1) {
            return Messages.get("Quest.hero.title");
        }
    }

    if (Messages.has(`Quest.${this.id}.title`)) {
        return Messages.get(`Quest.${this.id}.title`, toReplace);
    }

    return Messages.get(`Quest.${this.type}.title`, toReplace);
};

Quest.prototype.save = function () {
    const info = {
        id: this.id,
        goal: this.goal,
        progress: this.progress
    };

    if (this.fresh) {
        info.fresh = 1;
    }
    if (this.unit && this.unit !== this.config.unit) {
        info.unit = this.unit;
    }
    if (this.recipeCode) {
        info.recipe = this.recipeCode;
    }

    return info;
};

Quest.prototype.getDialogue = function () {
    return QuestsConfig[cleverapps.meta.selectedLocationId()][this.id].dialogue;
};

Quest.prototype.getTutorial = function (onFinish) {
    const questConfig = QuestsConfig[cleverapps.meta.selectedLocationId()][this.id];
    if (!questConfig) {
        return;
    }

    let tutor = onFinish ? questConfig.finishTutorial : questConfig.tutorial;
    const tutorData = Map2dLocation.currentLocation && Map2dLocation.currentLocation.getMergeTutorial(tutor);
    if (tutor && tutorData) {
        tutor = tutorData;
        if (!tutor.filter || tutor.filter()) {
            return tutor;
        }
    } else {
        return cleverapps.tutorial.findScenario(tutor);
    }
};

Quest.prototype.showTutorial = function (f, onFinish) {
    const tutorial = this.getTutorial(onFinish);

    if (!tutorial) {
        f();
        return;
    }

    if (Map2dLocation.currentLocation && Map2dLocation.currentLocation.getMergeTutorial(tutorial.id)) {
        Map2dLocation.currentLocation.tutorial.showTutorial(tutorial, f);
    } else {
        cleverapps.tutorial.startScenario(tutorial);
        f();
    }
};

Quest.prototype.replayTutorial = function () {
    if (this.isFinished()) {
        return;
    }

    const tutorial = this.getTutorial();
    if (tutorial && tutorial.replayOnReload) {
        tutorial.replayed = true;
        Map2dLocation.currentLocation.tutorial.triggerTutorial(tutorial);
    }
};

Quest.prototype.isApplicable = function (type, options) {
    options = options || {};

    if (this.config.type === Map2d.BUILD && type === Map2d.SPAWN && (options.debug
        || (options.affected && ["thirdelement", "t"].includes(options.affected.code)))) {
        return Unit.IsApplicable(this.unit, options.unit);
    }

    if (this.config.type !== type) {
        return false;
    }

    let eventUnit = options.unit || options.affected;
    if (Array.isArray(eventUnit)) {
        eventUnit = eventUnit[0];
    }

    switch (type) {
        case Map2d.MERGE:
            return (!this.config.minUnits || options.affected.length >= this.config.minUnits)
                && (!this.config.unit || options.affected.some(Unit.Equals.bind(Unit, this.config.unit)));
        case Map2d.SPAWN:
        case Map2d.OPEN_UNIT:
        case Map2d.MINE:
        case Map2d.COMPLETE_MINING:
        case Map2d.BUILD:
        case Map2d.HARVEST:
        case Map2d.PRIZE_HARVESTED:
            return Unit.IsApplicable(this.unit, eventUnit);
        case Map2d.BUY_FREE_UNIT:
            return options.tab === this.config.tab;
        case Map2d.OPENFOG:
            return !this.config.target || options.fog === this.config.target;
        case Map2d.RECIPE_READY:
            return options.source.recipe.code === this.recipeCode;
        case Map2d.EXCHANGE:
            return !this.unit || Unit.IsApplicable(this.unit, eventUnit);
    }

    return true;
};

Quest.prototype.getIcon = function () {
    let icon;
    if (this.dynamic.getIcon) {
        icon = this.dynamic.getIcon(this.unit, this);
        if (icon) {
            return icon;
        }
    }

    icon = Quest.GetUnitIconResource(this.id);
    if (icon) {
        return new cc.Sprite(icon);
    }

    if (this.campaign) {
        icon = Campaign.getCampaignQuestIcon(this.unit);
        if (icon) {
            return icon;
        }
    }

    switch (this.type) {
        case Map2d.SPAWN: case Map2d.OPEN_UNIT: case Map2d.BUILD: case Map2d.MINE: case Map2d.HARVEST:
        case Map2d.PRIZE_HARVESTED: case Map2d.COMPLETE_MINING: case Map2d.BUY_FREE_UNIT:
            return UnitView.getUnitImage(this.unit, { alignAnchorX: true, preferStatic: true });

        case Map2d.OPENFOG:
            return new cc.Sprite(bundles.quest_icons.frames.fog_icon_png);
    }
};

Quest.GetUnitIconResource = function (id) {
    const res = bundles.quest_icons.frames[`${cleverapps.meta.selectedLocationId()}_${id}`] || bundles.quest_icons.frames[`${cleverapps.skins.getSlot("skinName")}_${id}`];
    return res && res.resolve();
};

Quest.GetId = function (quest) {
    return quest.id;
};
